import React, { useRef, useLayoutEffect, useState } from "react";
import styles from "./RegisterStep.module.css";

const RegisterStep = ({ compatedStep }) => {
  const stepLabel = [
    { key: 1, value: "Business Information" },
    { key: 2, value: "Trade References" },
    { key: 3, value: "Policies" },
  ];

  // Refs for each step
  const stepRefs = useRef([]);
  const [firstLineWidth, setFirstLineWidth] = useState();

  useLayoutEffect(() => {
    if (stepRefs.current[0] && stepRefs.current[1]) {
      const first = stepRefs.current[0].getBoundingClientRect();
      const second = stepRefs.current[1].getBoundingClientRect();
      // Calculate distance from right edge of first to center of second
      const width = second.left + second.width / 2 - (first.left + first.width);
      setFirstLineWidth(width > 0 ? width : 0);
    }
  }, [stepRefs, compatedStep]);

  const connectorWidth = `${100 / (stepLabel.length - 1)}%`;

  return (
    <div className={styles.registerStepLine}>
      {stepLabel.map((item, index) => (
        <React.Fragment key={item.key}>
          <div
            className={styles.stepWrapper}
            ref={(el) => (stepRefs.current[index] = el)}
          >
            {index < compatedStep - 1 ? (
              <div className={styles.circleCompleted}>{item.key}</div>
            ) : index === compatedStep - 1 ? (
              <div className={styles.pill}>
                <span className={styles.circleActive}>{item.key}</span>
                <span className={styles.label}>{item.value}</span>
              </div>
            ) : (
              <div className={styles.circleInactive}>{item.key}</div>
            )}
          </div>
          {index < stepLabel.length - 1 && (
            <div
              className={
                index < compatedStep - 1
                  ? styles.lineConnectorCompleted
                  : styles.lineConnector
              }
              style={
                index === 0 && firstLineWidth !== undefined
                  ? { width: firstLineWidth }
                  : { width: connectorWidth }
              }
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default RegisterStep;
